import React from "react";
export default function FloodNotice() {
  return (
    <aside className="notice">
      <p>
        Council flood awareness data is not intended for due diligence or
        conveyancing. Obtain the relevant council report or planning and
        development certificate. Parcel flags do not establish flood depth,
        building exposure or insurance cover.
      </p>
      <a href="https://www.brisbane.qld.gov.au/building-and-planning/supporting-documents-and-online-tools/floodwise-property-report">
        Get the council FloodWise Property Report
      </a>
    </aside>
  );
}
